import {
  BalanceUpdateService,
  NUMBER_FORMATTER_TOKEN,
  NumberFormatter,
  SimpleUserInfoHolder,
  SlotOnlyAuthorizationHolder,
  T_IAuthorizationHolder,
  T_IBalanceUpdater,
  T_IBalanceUpdaterRegistrator,
  T_ISimpleUserInfoHolder,
} from '@cgs/common';
import {
  BET_STORE_TOKEN,
  BetStore,
  LAUNCH_PARAMS_STORE_TOKEN,
  LaunchParamsStore,
  SLOT_MACHINE_STORE_TOKEN,
  SlotMachineStore,
} from '@cgs/machines';

import {
  AlertManager,
  ApplicationGameConfig,
  ApplicationUserConfig,
  ALERT_MANAGER_TOKEN,
  T_Translations,
  Translations,
  Lazy,
} from '@cgs/shared';
import { Container, InstanceLifetime } from '@cgs/wge';
import { GAME_DATA_SERVICE_TOKEN, GameDataService } from '../services/game-data.service';
import {
  FALLBACK_MACHINE_STATE_SERVICE_TOKEN,
  FallbackMachineStateService,
} from '../services/fallback-machine-state.service';

export class GameProvider {
  constructor(protected container: Container) {}

  public register(): void {
    this.container.register(
      T_Translations,
      () => new Translations(`configs/translations-${ApplicationUserConfig.language}.json`),
      { lifetime: InstanceLifetime.Singleton }
    );
    this.container.register(
      ALERT_MANAGER_TOKEN,
      (container) => new AlertManager(container, `games/${ApplicationGameConfig.gameId}` || ''),
      {
        lifetime: InstanceLifetime.Singleton,
      }
    );

    const balanceUpdateService = new Lazy<BalanceUpdateService>(() => new BalanceUpdateService());

    this.container.register(T_IBalanceUpdater, () => balanceUpdateService.call(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(T_IBalanceUpdaterRegistrator, () => balanceUpdateService.call(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(T_IAuthorizationHolder, () => new SlotOnlyAuthorizationHolder(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(T_ISimpleUserInfoHolder, () => new SimpleUserInfoHolder(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(
      GAME_DATA_SERVICE_TOKEN,
      (container) => new GameDataService(container),
      {
        lifetime: InstanceLifetime.Singleton,
      }
    );
    this.container.register(
      FALLBACK_MACHINE_STATE_SERVICE_TOKEN,
      (container) => new FallbackMachineStateService(container),
      {
        lifetime: InstanceLifetime.Singleton,
      }
    );
    this.container.register(LAUNCH_PARAMS_STORE_TOKEN, () => new LaunchParamsStore(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(SLOT_MACHINE_STORE_TOKEN, () => new SlotMachineStore(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(NUMBER_FORMATTER_TOKEN, () => new NumberFormatter(), {
      lifetime: InstanceLifetime.Singleton,
    });
    this.container.register(BET_STORE_TOKEN, () => new BetStore(), {
      lifetime: InstanceLifetime.Singleton,
    });
  }
}
